export const state = () => {
	return {
		isLoading: false,
	}
}

export const actions = {
	async retrieve(_, { companyId, creatorId }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/creators/${creatorId}/`)
	},

	async delete(_, { creatorId }) {
		return await useNuxtApp()
			.$api(`/api/creators/${creatorId}/`, { method: 'DELETE' })
			.then((res) => {
				return res
			})
	},

	async getAmbassadors({ commit, rootGetters }, { params }) {
		// query ambassadors matching the parameters.
		commit('setIsLoading', true)

		const {
			targeting_ids: targetingIds,
			level_ids: levleIds,
			age_range: ageRange,
			gender,
			limit,
			...restParams
		} = params

		let searchUrl = `api/companies/${rootGetters.companyId}/creators/?limit=${limit}`

		if (gender) {
			gender.forEach((gender) => {
				searchUrl += `&gender[]=${gender}`
			})
		}

		if (ageRange) {
			ageRange.forEach((age) => {
				searchUrl += `&age_range[]=${encodeURIComponent(age)}`
			})
		}

		if (targetingIds) {
			targetingIds.forEach((targeting_id) => {
				searchUrl += `&targeting_ids[]=${targeting_id}`
			})
		}

		if (levleIds) {
			levleIds.forEach((level_id) => {
				searchUrl += `&level_ids[]=${level_id}`
			})
		}
		return await useNuxtApp()
			.$api(searchUrl, { params: restParams })
			.then((res) => {
				res.results.forEach((creator) => {
					// initialize selection variable (all results start unselected)
					creator.selected = false
				})

				commit('setIsLoading', false)
				return res
			})
	},

	async nextAmbassadors({ commit }, { nextURL }) {
		// call the next batch of ambassadors when we reached the bottom of the page.
		commit('setIsLoading', true)

		return await useNuxtApp()
			.$api(nextURL)
			.then((res) => {
				commit('setIsLoading', false)
				return res
			})
	},

	async getAmbassadorsCSV({ rootGetters }, { params, selected }) {
		// query ambassadors matching parameters, expecting CSV data as output.
		const paramsCSV = { export: true }
		Object.assign(paramsCSV, params)

		return await useNuxtApp()
			.$api(`/api/companies/${rootGetters.companyId}/creators/`, { params: paramsCSV })
			.then((res) => {
				// if elements are selected, filter results on them
				if (selected.length > 0) {
					const selectedEmails = selected.map((el) => el.email)
					const dataLines = res.split('\n')
					const filteredLines = dataLines.filter((line) =>
						selectedEmails.includes(line.split(',')[0]),
					)
					res = filteredLines.join('\n')
				}
				// create downloadable CSV file from data
				const url = window.URL.createObjectURL(new Blob([res]))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', `utilisateurs.csv`)
				document.body.appendChild(link)
				link.click()
				link.remove()
			})
			.catch((err) => {
				return err
			})
	},
}

export const mutations = {
	setIsLoading(state, isLoading) {
		state.isLoading = isLoading
	},
}
